import React, { DetailedHTMLProps, ButtonHTMLAttributes } from 'react';

import { Button } from '../Button';

import styles from './NextButton.module.scss';

export interface INextButtonProps extends DetailedHTMLProps<ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>{
    text: string;
    disabled?: boolean;
}

export const NextButton = ({text = 'Next', ...props}: INextButtonProps) => {
    return (
        <Button
            text={text}
            wrapperClass={styles.nextButtonWrapper}
            buttonClass={styles.nextButton}
            {...props} />
    );
};
